import { createAsyncThunk } from '@reduxjs/toolkit';

import { MyInvestmentsService } from 'api';

import { IInvestSecondaryMarketProps } from 'models/api';

import { asyncPayloadCreator } from 'utils';

export const cancelSaleInvestment = createAsyncThunk(
	'myInvestments/cancelSaleInvestment',
	(data: IInvestSecondaryMarketProps, { rejectWithValue }) =>
		asyncPayloadCreator(data, { rejectWithValue }, MyInvestmentsService.cancelSaleInvestment),
);
